var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPickBlackLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.605 23.7631C10.8591 23.9097 11.1721 23.9097 11.4261 23.7631L15.5035 21.4108C15.8967 21.184 16.0314 20.6812 15.8043 20.2882L11.0156 12H17.4738C17.7678 12 18.0393 12.157 18.1859 12.4117L19.8686 15.3354C20.2882 16.0644 21.4022 15.7667 21.4022 14.9256V6.4742C21.4022 6.18075 21.2457 5.90959 20.9916 5.7628L11.4265 0.237391C11.1722 0.0905036 10.8589 0.0905036 10.6046 0.237391L1.03952 5.7628C0.785423 5.90959 0.628906 6.18075 0.628906 6.4742V14.9256C0.628906 15.7667 1.74294 16.0644 2.16252 15.3354L3.84526 12.4117C3.99188 12.157 4.2634 12 4.55731 12H11.0156L6.22685 20.2882C5.99975 20.6812 6.13446 21.184 6.52766 21.4108L10.605 23.7631Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPickBlackLogo);
export default __webpack_public_path__ + "static/media/PickBlackLogo.66643a7b96e3c5c44366921bb0274cae.svg";
export { ForwardRef as ReactComponent };